import { render } from "./TabTrigger.vue?vue&type=template&id=54128ed9"
import script from "./TabTrigger.vue?vue&type=script&lang=js"
export * from "./TabTrigger.vue?vue&type=script&lang=js"
script.render = render

export default script